import { Component } from '@angular/core';
import { BannerAppComponent } from "../banner-app/banner-app.component";
import { FooterAppComponent } from "../footer-app/footer-app.component";
import { ActivatedRoute, Router } from '@angular/router';
import { REDIRECT } from '../../routes.constans';

@Component({
  selector: 'app-sin-zona',
  standalone: true,
  imports: [BannerAppComponent, FooterAppComponent],
  templateUrl: './sin-zona.component.html',
  styleUrls: ['./sin-zona.component.scss']
})

export class SinZonaComponent {
  codAsesor: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {

  }

  volverInicio(): void {
    if (this.codAsesor === undefined || this.codAsesor === '') {
      this.router.navigate([REDIRECT]);
    } else {
      this.router.navigate([REDIRECT], { queryParams: { codigoAsesor: this.codAsesor } });
    }
  }
}
